import React, {useEffect, useState, useContext } from 'react'
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  Header,
  LanguageSwitcherContainer,
  HeadlineContainer,
  StrongHeadline,
  SubheadLine,
  Body,
  SubmitButton,
  SubmitLink,
} from "../components/Checkin/checkin.styles";

import AdminLoginForm from '../components/LoginFormAdmin/loginAdmin.component';

import LanguageSwitcherSelector from "../components/language-switcher/language-switcher.component";
import { UserContext } from '../contexts/user.context';
import { auth } from '../utils/firebase/firebase.utils';

const AdminLogin = () => {

    const navigate = useNavigate();

    const {currentUser} = useContext(UserContext)

    const {t} = useTranslation()

    useEffect(()=> {
      if (!currentUser) {
        navigate('/admin')
      } else {
        navigate('/admin/create-booking')
      }
  }, [currentUser])

  return (
    <>
    <Header>
        <LanguageSwitcherContainer>
          <LanguageSwitcherSelector />
        </LanguageSwitcherContainer>
        <button
          style={{
            width: "25px",
            height: "25px",
            margin: "20px",
            backgroundColor: "transparent",
            border: "0",
            cursor: "pointer",
          }}
        >
        </button>
      </Header>
      <Body>
        <HeadlineContainer>
          <StrongHeadline>{t('admin_login_headline')}</StrongHeadline>
          <SubheadLine>
            {t('admin_login_subheadline')}
          </SubheadLine>
        </HeadlineContainer>
        <AdminLoginForm />
        <SubmitButton inverted="true" style={{ display: 'flex', margin:'auto' }}>
        <SubmitLink style={{ display: 'flex', margin:'auto'}} inverted="true" to="/">
          {t('admin_login_back_button')}
        </SubmitLink>
      </SubmitButton>
      </Body>
    {/* <Footer /> */}
    </>
  )
}

export default AdminLogin